var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserICon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8033 11.6967C13.9864 10.8798 13.0141 10.2751 11.9533 9.90904C13.0895 9.12649 13.8359 7.81684 13.8359 6.33594C13.8359 3.94511 11.8908 2 9.5 2C7.10917 2 5.16406 3.94511 5.16406 6.33594C5.16406 7.81684 5.91052 9.12649 7.04674 9.90904C5.9859 10.2751 5.01359 10.8798 4.19671 11.6967C2.91902 12.9744 2.15908 14.6319 2.02236 16.4146C1.99761 16.7372 2.26233 17 2.58594 17C2.90954 17 3.16903 16.7368 3.19872 16.4146C3.49507 13.1986 6.20801 10.6719 9.5 10.6719C12.792 10.6719 15.5049 13.1986 15.8013 16.4146C15.831 16.7368 16.0905 17 16.4141 17C16.7377 17 17.0024 16.7372 16.9776 16.4146C16.8409 14.6319 16.081 12.9744 14.8033 11.6967ZM9.5 9.5C7.75534 9.5 6.33594 8.08063 6.33594 6.33594C6.33594 4.59125 7.75534 3.17188 9.5 3.17188C11.2447 3.17188 12.6641 4.59125 12.6641 6.33594C12.6641 8.08063 11.2447 9.5 9.5 9.5Z",
    fill: "#8E8A8B",
    stroke: "#8E8A8B",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserICon);
export default __webpack_public_path__ + "static/media/userICon.41c580a6f48ced71a467e1bbc9f53c37.svg";
export { ForwardRef as ReactComponent };